var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCaseCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M6.167 2.5h11.666c.92 0 1.667.895 1.667 2v15c0 1.105-.746 2-1.667 2H6.167c-.92 0-1.667-.895-1.667-2v-15c0-1.105.746-2 1.667-2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  d: "M11.25 19.5h6.25v-2.25h-6.25v2.25zm-4.75 0h2.75v-2.25H6.5v2.25zm4.75-4.25h6.25V13h-6.25v2.25zm-4.75 0h2.75V13H6.5v2.25zM11.25 11h6.25V8.75h-6.25V11zM6.5 11h2.75V8.75H6.5V11zm0-4.25h11V4.5h-11v2.25z"
})))));
export default SvgIconCaseCard;